import React, { useState } from 'react';
import ClampLines from 'react-clamp-lines';
import { Paper, makeStyles, Grid, Icon, colors } from '@material-ui/core';
import { AccessTime } from '@material-ui/icons';

import Routes from 'config/routes';

import Description from 'components/typography/Description';
import Link from 'components/Link';

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '100%',
  },
  paper: {
    borderRadius: '8px',
    padding: 16,
    height: '100%',
  },
  image: {
    height: 160,
    backgroundColor: colors.grey[50],
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
    boxShadow: '0px 0px 16px -8px rgba(0,0,0,0.64)',
  },
  emptyImage: {
    height: 160,
    width: '100%',
  },
  description: {
    whiteSpace: 'pre-wrap',
    lineHeight: 1.5,
    textOverflow: 'ellipsis',
    maxHeight: 3.0,
    wordWrap: 'break-word',
    fontFamily: 'Varela Round, sans-serif',
    fontSize: '1rem',
  },
});

const BigRecipeCard = ({ recipeModel }) => {
  const classes = useStyles();
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <div className={classes.root}>
      <Link pathname={Routes.recipe(recipeModel.id)}>
        <Paper
          elevation={isMouseOver ? 6 : 3}
          onMouseEnter={() => setIsMouseOver(true)}
          onMouseLeave={() => setIsMouseOver(false)}
          className={classes.paper}
        >
          <Grid container direction="column" style={{ height: '100%' }}>
            {recipeModel.content.additionalData.coverPhotoURL && (
              <Grid item container>
                <RecipePhotoCover
                  coverPhotoURL={
                    recipeModel.content.additionalData.coverPhotoURL
                  }
                ></RecipePhotoCover>
              </Grid>
            )}

            <Grid
              item
              container
              direction="column"
              spacing={1}
              style={{
                marginTop: recipeModel.content.additionalData.coverPhotoURL
                  ? 16
                  : 0,
                flexGrow: 1,
              }}
            >
              <Grid item container>
                <Description>
                  <b>{recipeModel.content.title}</b>
                </Description>
              </Grid>

              {recipeModel.content.additionalData.description && (
                <Grid item>
                  <RecipeDescription
                    description={recipeModel.content.additionalData.description}
                    id={recipeModel.id}
                  ></RecipeDescription>
                </Grid>
              )}

              <div style={{ flexGrow: 1 }}></div>

              <Grid item container>
                <TimeToPrepare
                  timeToPrepare={recipeModel.content.timeToPrepare}
                ></TimeToPrepare>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Link>
    </div>
  );
};

const RecipePhotoCover = ({ coverPhotoURL }) => {
  const classes = useStyles();

  if (!coverPhotoURL) return <div className={classes.emptyImage}></div>;

  return (
    <img className={classes.image} src={coverPhotoURL} alt="Recipe Cover"></img>
  );
};

const RecipeDescription = ({ description, id }) => {
  const classes = useStyles();

  return (
    <span className={classes.description}>
      <ClampLines
        text={description}
        lines={4}
        ellipsis="..."
        buttons={false}
        id={id}
      ></ClampLines>
    </span>
  );
};

const TimeToPrepare = ({ timeToPrepare }) => {
  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <Description>{timeToPrepare} min</Description>
      </Grid>

      <Grid item>
        <Icon>
          <AccessTime fontSize="small"></AccessTime>s
        </Icon>
      </Grid>
    </Grid>
  );
};

export default BigRecipeCard;
